import { useTemplateDataSafe } from '@/contexts/TemplateDataContext';
import templateDataService from '@/services/template-data-service';

/**
 * Hook that safely gets template data from context or service fallback
 * Returns null if data is not available
 */
export const useSafeTemplateData = () => {
  const contextData = useTemplateDataSafe();

  // Fallback to service if context is not available (backwards compatibility)
  if (contextData === null) {
    const serviceData = templateDataService.getTemplateData();
    return serviceData || null;
  }

  return contextData;
};
